import { Component } from '@angular/core';

import { APIService } from '../services';

@Component({
  templateUrl: 'control.component.html',
  styleUrls: ['./control.component.scss'],
  providers: [APIService]
})
export class ControlComponent {
  multiplierValue: number;
  thresholdValue: number;
  gainValue: number;
  testMode: boolean = false;

  response: any;

  constructor(
    private apiService: APIService
  ) {}

  command(command: string, value: number = 0): void {
    this.response = 'Loading...';
    this.apiService.command(command, value, this.testMode).subscribe(
      response => {
        if(response.message) {
          console.log(response);
          this.response = response.message;
        } else {
          this.response = 'Empty response';
        }
      },
      error => {
        console.error(error);
        this.response = 'error';
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/control/control.component.ts